import axios from 'axios';
import { getPublicUrl } from '../../appconfig';

export const sendSmsMobile = (body) => {
  const url = `${getPublicUrl()}/api/sendSms`;

  let data = axios
    .post(url, body)
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      // console.log("Error Occured", e.response.data);
    });

  return data;
};
